import React, { useContext, useEffect, useState } from "react";
import { InputSearch } from "@components/inputSearch";
import { Context } from "@components/useContext/context";
import ImageContainer from "@components/imageContainer";
import {
  Wrapper,
  GridContainer,
  CardWrapper,
  ImageWrapper,
  CardLabel
} from "./styles";
import UnableToFindBrandCard from "@components/unableToFindCard";
import { fetchConfigAndRedirect } from "@actions/fetchConfigRedirect";
import { executeActions } from "@utils/index";
import { analyticEvents as triggerAnalyticEvent } from "@actions/analyticEvents";
import { getRequestpayload } from "@utils/index";
const NewCarMakeSelection = (props: any) => {
  const {actions} = props;
  const {on_unable_to_find_card_click, on_make_not_found_click} = actions || [];
  const { isDesktop } = useContext(Context);
  const [input, setInput] = useState<string>("");
  const [query, setQuery] = useState<string>("");
  const [searchInputPlaceholder, setSearchInputPlaceholder] = useState<string>(
    "Search your car's brand"
  );
  const { brands, selected_make_id, unableToFindBrandCard } = props;
  const selectedMake =
    brands && brands.find((brand) => brand.make_id === selected_make_id);
  const [displayedBrandList, setDisplayedBrandList] = useState<any[]>(
    brands || []
  );
  const searchBrands = (input: string) => {
    return brands.filter((brand) =>
      brand.make_name.toLowerCase().includes(input.toLowerCase())
    );
  };
  // const popularBrands = brands.filter((brand) => brand.is_popular); // commented as it was decided to show all the brancds at first go
  const popularBrands = brands;
  useEffect(() => {
    if (input.length > 0) {
      const filteredBrands = searchBrands(input);
      console.log(filteredBrands)
      if(filteredBrands?.length === 0) {
        executeActions(on_make_not_found_click, {
          customData: {
            search_term: input
          }
        })
      }
      setDisplayedBrandList(filteredBrands);
    } else {
      // Add selected make to popular brands if it's not already there
      const brandsToShow = [...(popularBrands || [])];
      if (
        selectedMake &&
        !popularBrands.some((brand) => brand.make_id === selectedMake.make_id)
      ) {
        brandsToShow.unshift(selectedMake);
      }
      setDisplayedBrandList(brandsToShow);
    }
  }, [input]);

  const handleMakeSelection = (makeId: string, makeName: string) => {
    const currentYear = new Date().getFullYear();
    const { data, journey } = getRequestpayload();
    triggerAnalyticEvent({
      edata: {
        product: data.product,
        action_name: "tap_btn_make_selected",
        action_type: "tap_btn",
        make:makeId
      },
      odata: {
        journey
      },
      event_name: "action"
    });
    fetchConfigAndRedirect({
      requestBody: {
        current_node: "make_selection_node"
      },
      data: {
        make_id: makeId,
        make: makeName,
        registration_year: currentYear,
        manufacturing_year: currentYear,
      },
      shouldRedirect: true,
      isRouterReplace: false,
      showCustomBasicLoader: true,
      showCustomLottie: false
    });
  };

  const onSearchCallback = () => {
    const { data, journey } = getRequestpayload();
    triggerAnalyticEvent({
      edata: {
        product: data.product,
        action_name: "tap_btn_search_make",
        action_type: "tap_btn",
      },
      odata: {
        journey
      },
      event_name: "action"
    });
  };

  return (
    <Wrapper>
      <InputSearch
        isDesktop={isDesktop}
        placeholder={searchInputPlaceholder}
        searchInput={input}
        setSearchInput={setInput}
        query={query}
        searchCallback={onSearchCallback}
      />
      <GridContainer>
        {displayedBrandList.map((brand) => (
          <Card
            key={brand.make_id}
            brand={brand}
            isSelected={brand.make_id === selected_make_id}
            onClick={() => handleMakeSelection(brand.make_id,brand.make_name)}
          />
        ))}
      </GridContainer>
      {displayedBrandList.length === 0 && (
        <UnableToFindBrandCard
          imgSrc={unableToFindBrandCard.imgSrc}
          alt={unableToFindBrandCard.alt}
          height={unableToFindBrandCard.height}
          width={unableToFindBrandCard.width}
          title={unableToFindBrandCard.title}
          buttonLabel={unableToFindBrandCard.buttonLabel}
          isFullWidth={unableToFindBrandCard.isFullWidth}
          onClick={() => {executeActions(on_unable_to_find_card_click);}}
        />
      )}
    </Wrapper>
  );
};

export const Card = (props: any) => {
  const { brand, isSelected, onClick } = props;
  return (
    <CardWrapper isSelected={isSelected} onClick={onClick}>
      <ImageWrapper isSelected={isSelected}>
        <ImageContainer
          imgSrc={brand.logo_url}
          alt={brand.make_name}
          height={32}
          width={32}
        />
      </ImageWrapper>
      <CardLabel>{brand.make_name}</CardLabel>
    </CardWrapper>
  );
};

export default NewCarMakeSelection;
